import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../../supabaseClient"; // Import Supabase client
import ConfirmationPopup from "../common/ConfirmationPopup"; // Import ConfirmationPopup component
import Cookies from "js-cookie"; // Import Cookies

import SessionPopup from "../common/SessionPopup"; // Import SessionPopup component
import {
  removeSessionandChatHistory,
  storeChatHistory,
} from "../../chatHistory"; // Import removeSessionandChatHistory function
import { createChatSession } from "../../chatSession"; // Import createChatSession function
import useResetSession from "../common/ResetSession"; // Import useResetSession hook
import LoaderElement from "../common/Loader";

function MainSession({ isSideConvoChannelUpdateList, isSidebarVisible }) {
  const [sessions, setSessions] = useState([]);
  const [userId, setuserId] = useState(null);
  const [showOptions, setShowOptions] = useState(null);
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [sessionToRemove, setSessionToRemove] = useState(null);
  const [sessionToRename, setSessionToRename] = useState(null);
  const [isNewSession, setIsNewSession] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(null);
  const [showSubSubMenu, setShowSubSubMenu] = useState(null); // Add state for sub-sub menu
  const [searchQuery, setSearchQuery] = useState("");
  const [childSessions, setChildSessions] = useState({});
  const [allChildSessions, setAllChildSessions] = useState({});

  const [activeParentId, setActiveParentId] = useState(null);
  const [activeSessionDelete, setActiveSessionDelete] = useState(false);

  const [loadSideConvo, setLoadSideConvo] = useState(true);
    
  const [checkedSessions, setCheckedSessions] = useState([]);
  const [deleteAllChecked, setDeleteAllChecked] = useState(false);
  const mainSessionRef = useRef(null);
  const resetSession = useResetSession(); // Initialize the useResetSession hook
  const activeSessionId = Cookies.get("chat_session_id"); // Get the active session ID from cookies
  const optionsRef = useRef(null);
  const childRef = useRef(null);
  const sessionScrollRef = useRef(null);

  const ulRef = useRef(null);
  const scrollPosition = useRef(0);

  useLayoutEffect(() => {
    const ul = ulRef.current;
    if (ul) scrollPosition.current = ul.scrollTop;
  });

  useEffect(() => {
    const ul = ulRef.current;
    if (ul) ul.scrollTop = scrollPosition.current;
  });

  const handleOptionsClick = (sessionId) => {
    setShowOptions(showOptions === sessionId ? null : sessionId);
    // Add a slight delay to ensure the popup renders before checking visibility
  };
  // useEffect(() => {
  //   if (showOptions) {
  //     const container = document.querySelector('.sessionBox')
  //     const optionRefContainer = optionsRef.current

  //         // Scroll the container to align with the container's bottom
  //         container.scrollTo({
  //           top: container.scrollTop + optionRefContainer.scrollHeight,
  //           behavior: 'smooth'
  //         })
  //   }
  // }, [showOptions])
  useEffect(() => {
    if (showOptions && ulRef.current && optionsRef.current) {
      const container = ulRef.current;
      const popup = optionsRef.current;

      const containerRect = container.getBoundingClientRect();
      const popupRect = popup.getBoundingClientRect();

      // Check if popup is outside the visible container (bottom overflow)
      if (popupRect.bottom > containerRect.bottom) {
        const scrollOffset = popupRect.bottom - containerRect.bottom + 10; // 10px buffer
        container.scrollBy({
          top: scrollOffset,
          behavior: "smooth",
        });
      }

      // Optional: handle top overflow too
      else if (popupRect.top < containerRect.top) {
        const scrollOffset = containerRect.top - popupRect.top + 10;
        container.scrollBy({
          top: -scrollOffset,
          behavior: "smooth",
        });
      }
    }
  }, [showOptions]);

  const fetchSessions = async () => {
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();
    if (session) {
      // Fetch parent sessions (where parent_session is null)
      const { data: parentSessions, error: parentError } = await supabase
        .from("chat_session")
        .select("*")
        .eq("type", "topic")
        .eq("user_auth", session.user.id)
        .is("parent_session", null)
        .order("updated_at", { ascending: false });

      if (parentError) {
        console.error("Error fetching parent sessions:", parentError);
      } else {
        // Fetch child sessions for each parent session
        const { data: allChild, error: allChildError } = await supabase
          .from("chat_session")
          .select("*")
          .eq("type", "sub_topic")
          .eq("user_auth", session.user.id)
          .in("parent_session", parentSessions.map((s) => s.id))
          .order("updated_at", { ascending: false });
        
          
        const childSessionsMap = {};
        for (const parentSession of allChild) {
            if (!childSessionsMap[parentSession.parent_session]) {
                childSessionsMap[parentSession.parent_session] = [];
            }
            childSessionsMap[parentSession.parent_session].push(parentSession);
        }
        setAllChildSessions(childSessionsMap);
        setSessions(parentSessions);
        setLoadSideConvo(false);
        setuserId(session.user.id);
      }
    }
  };

  const fetchChildSessions = async (parentId) => {
    if (userId && parentId) {
      const { data: childSessions, error } = await supabase
        .from("chat_session")
        .select("*")
        .eq("type", "sub_topic")
        .eq("user_auth", userId)
        .eq("parent_session", parentId)
        .order("updated_at", { ascending: false });

      if (!error) {
        setChildSessions((prev) => ({
          ...prev,
          [parentId]: childSessions,
        }));
      }
    }
  };

  useEffect(() => {
    fetchSessions();
    fetchChildSessions();
  }, [isSideConvoChannelUpdateList]);

  useEffect(() => {
    fetchSessions().then(() => {
      const checkParentSession = async () => {
        if (activeSessionId) {
          const { data, error } = await supabase
            .from("chat_session")
            .select("parent_session")
            .eq("id", activeSessionId)
            .single();

          if (!error && data?.parent_session) {
            setActiveParentId(data.parent_session);
            setShowSubSubMenu(data.parent_session); // Auto-expand parent menu
            if (!childSessions[data.parent_session]) {
              await fetchChildSessions(data.parent_session);
            }
          } else {
            setActiveParentId(null);
          }
        }
      };

      checkParentSession();
    });
  }, [activeSessionId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close dropdown when clicking outside of it
      if (showOptions !== null) {
        const clickedOnDropdown = optionsRef.current && optionsRef.current.contains(event.target);
        const clickedOnThreeDot = event.target.closest('.bi-three-dots-vertical');

        if (!clickedOnDropdown && !clickedOnThreeDot) {
          setShowOptions(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  useEffect(() => {
    if (activeParentId && !childSessions[activeParentId]) {
      fetchChildSessions(activeParentId);
    }
  }, [activeParentId]);

  // const handleOptionsClick = sessionId => {
  //   setShowOptions(showOptions === sessionId ? null : sessionId)
  // }

  const handleRename = (sessionId) => {
    // Close the dropdown menu first to prevent interference
    setShowOptions(null);
    setSessionToRename(sessionId);
    setIsNewSession(false);
    setShowFormPopup(true);
  };

  const handleRemove = (sessionId) => {
    // Close the dropdown menu first to prevent interference
    setShowOptions(null);
    if (sessionId) {
      setSessionToRemove(sessionId);
    } else {
      setSessionToRemove(null);
    }
    setShowRemovePopup(true);
  };

  const handleNewSession = (parentId = null) => {
    setIsNewSession(true);
    setSessionToRename(parentId);
    setShowFormPopup(true);
  };

  const confirmRemove = async (type) => {
    setLoader(true);
    if (type) {
      await deletSelectedSesion();
      setShowRemovePopup(false);
    } else {

      // Check if active session is a child of the session being deleted
      let isActiveSessionChild = false;
      const { data: childSessionsToDelete, error: childError } = await supabase
        .from("chat_session")
        .select("id")
        .eq("parent_session", sessionToRemove);

      if (!childError && childSessionsToDelete && childSessionsToDelete.length > 0) {
        isActiveSessionChild = childSessionsToDelete.some(child => child.id === activeSessionId);
      }

      const removeSessionAndChildren = async (sessionId) => {
        const { data: childSessions, error } = await supabase
          .from("chat_session")
          .select("id")
          .eq("parent_session", sessionId);

        if (!error && childSessions.length > 0) {
          for (const child of childSessions) {
            await removeSessionandChatHistory(child.id, userId);
          }
        }

        await removeSessionandChatHistory(sessionId, userId);
      };

      await removeSessionAndChildren(sessionToRemove).then(async () => {
        setLoader(false);
        setShowRemovePopup(false);
        // Check if deleted session is active OR if active session was a child of deleted parent
        if (sessionToRemove === activeSessionId || isActiveSessionChild) {
          const { data, error } = await supabase
            .from("chat_session")
            .select("id")
            .eq("user_auth", userId)
            .neq("id", sessionToRemove)
            .order("created_at", { ascending: false })
            .limit(1)
            .single();

          if (data != null && !error) {
            resetSession(data.id);
          } else {
            Cookies.remove("chat_session_id");
            window.location.reload();
          }
        } else {
          fetchSessions();
        }
      });
    }
  };

  const confirmRename = async (newName, setError) => {
    if (!newName.trim()) {
      setError("Topic name cannot be blank.");
      return;
    }
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();
    if (session) {
      let createdSession;
      try {
        if (isNewSession) {
          createdSession = await createChatSession(
            sessionToRename ? "sub_topic" : "topic",
            newName,
            session.user.id,
            null,
            sessionToRename
          );
           // Pass parentId if available
          // await storeChatHistory(
          //   createdSession[0].id,
          //   "Hi! 👋 How can I help you today?",
          //   "text",
          //   false
          // ).then(() => resetSession(createdSession[0].id));
          // Call resetSession with the created session ID
          //  .then(() => {

          // })
           resetSession(createdSession[0].id); // Only reset session, no default message
        } else {
          createdSession = await createChatSession(
            "main",
            newName,
            session.user.id,
            sessionToRename
          );
        }
        // await fetchSessions(); // Refresh sessions after rename or create
        // if(!Cookies.get('is_call')){
        //   window.location.reload(); // Reload the page after renaming
        // }
      } catch (err) {
        console.error("Error creating or renaming session:", err);
        setError("An error occurred while creating or renaming the session.");
      }
    }
    setShowFormPopup(false);
    setSessionToRename(null);
    setIsNewSession(false);
  };

  const handleSessionClick = async (sessionId, parentSession) => {
    if (parentSession) {
      const { error } = await supabase
        .from("chat_session")
        .update({ updated_at: new Date() })
        .eq("id", parentSession);
    } else {  
      const { error } = await supabase
        .from("chat_session")
        .update({ updated_at: new Date() })
        .eq("id", sessionId);
    }
    resetSession(sessionId); // Call resetSession with the clicked session's ID
  };

  const handleClosePopup = () => {
    setShowFormPopup(false);
  };

  const handleSubMenuClick = (sessionId) => {
    setShowSubMenu(showSubMenu === sessionId ? null : sessionId);
  };

  const handleSubSubMenuClick = async (sessionId) => {
    if (showSubSubMenu === sessionId) {
      setShowSubSubMenu(null);
    } else {
      setShowSubSubMenu(sessionId);
      if (!childSessions[sessionId]) {
        await fetchChildSessions(sessionId);
      }
    }
  };
  useEffect(() => {
    const container = document.querySelector(".sessionBox");
    const childContainer = childRef.current;
    if (container && childContainer) {
      container.scrollTo({
        top: container.scrollTop + (childContainer.scrollHeight),
        behavior: "smooth",
      });
    }
  }, [showSubSubMenu]);
  // const filteredSessions = sessions.filter(session =>
  //   session.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );
  const filteredSessions = sessions.filter((session) => {
    // Check if parent session name matches
    const parentMatch = session.name
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    // Check if any child session name matches
    const childMatch = allChildSessions[session.id]?.some((childSession) =>
      childSession.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Include session if parent or any child matches
    return parentMatch || childMatch;
  });

  useEffect(() => {
    if (searchQuery) {
      const matchingSession = Object.values(allChildSessions)
        .flat()
        .find((session) =>
          session.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
      if (matchingSession) {
        setShowSubSubMenu(matchingSession.parent_session);
      }
    }
  }, [searchQuery, allChildSessions]);
  // useEffect(() => {
  // }, childSessions)

  // const handleDeleteAll = () => {
  //   let allSession = [];
  //   filteredSessions.map((session) => {
  //     allSession.push(session.id);
  //   });
  //   setCheckedSessions(allSession);
  //   // } else {
  //   //   setCheckedSessions([]);
  //   // }
  // };

  // // const handleDeleteAll = () => {
  // //   setDeleteAllChecked(!deleteAllChecked);
  // //   if (deleteAllChecked == false) {
  // //     let allSession = [];
  // //     filteredSessions.map((session) => {
  // //       allSession.push(session.id);
  // //     });
  // //     setCheckedSessions(allSession);
  // //   } else {
  // //     setCheckedSessions([]);
  // //   }
  // // };

  const handleCheckboxChange = (sessionId) => {
    setCheckedSessions((prev) =>
      prev.includes(sessionId)
        ? prev.filter((id) => id !== sessionId)
        : [...prev, sessionId]
    );
  };
  const deletSelectedSesion = async () => {
    setLoader(true);

    // Check if active session is a child of any session being deleted
    let isActiveSessionChild = false;
    for (const sessionId of checkedSessions) {
      const { data: childSessionsToDelete, error: childError } = await supabase
        .from("chat_session")
        .select("id")
        .eq("parent_session", sessionId);

      if (!childError && childSessionsToDelete && childSessionsToDelete.length > 0) {
        if (childSessionsToDelete.some(child => child.id === activeSessionId)) {
          isActiveSessionChild = true;
          break;
        }
      }
    }

    // Check if active session is in the list of sessions being deleted
    const isActiveSessionDeleted = checkedSessions.includes(activeSessionId) || isActiveSessionChild;

    const removeSessionAndChildren = async (sessionId) => {
      const { data: childSessions, error } = await supabase
        .from("chat_session")
        .select("id")
        .eq("parent_session", sessionId);

      if (!error && childSessions.length > 0) {
        for (const child of childSessions) {
          await removeSessionandChatHistory(child.id, userId);
        }
      }

      await removeSessionandChatHistory(sessionId, userId);
    };

    // Delete all selected sessions
    for (const sessionToRemove of checkedSessions) {
      await removeSessionAndChildren(sessionToRemove);
    }

    setLoader(false);

    // After all deletions, check if we need to refresh
    if (isActiveSessionDeleted) {
      const { data, error } = await supabase
        .from("chat_session")
        .select("id")
        .eq("user_auth", userId)
        .not("id", "in", `(${checkedSessions.join(",")})`)
        .order("created_at", { ascending: false })
        .limit(1)
        .single();

      if (data != null && !error) {
        resetSession(data.id);
      } else {
        Cookies.remove("chat_session_id");
        window.location.reload();
      }
    } else {
      fetchSessions();
    }

    setCheckedSessions([]);
  };

   const setCombinedRefs = (node) => {
    ulRef.current = node;
    sessionScrollRef.current = node;
  };
  useEffect(() => {
  if (isSidebarVisible) {
    // Reset scroll for all tabs
    if (sessionScrollRef.current) sessionScrollRef.current.scrollTop = 0;
  }
      }, [isSidebarVisible]);
  return (
    <>
      {loadSideConvo?(
        <>
          <div style={{textAlign: "center", marginTop: "20px", color: "var(--teal-bg)"}}>
              <div className="loading-wave-container">
                  <div className="loading-wave"></div>
                  <div className="loading-wave"></div>
                  <div className="loading-wave"></div>
                  <div className="loading-wave"></div>
                  <div className="loading-wave"></div>
              </div>
          </div>
        </>
      ):(      
        <div ref={mainSessionRef}>
          <div
            className="search-container"
            style={{
              padding: "4px 12px 4px 24px"
            }}
          >
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* <i
                className="bi bi-search"
                style={{
                  position: "absolute",
                  left: "10px",
                  color: "#666",
                }}
              ></i> */}
              <input
                className="form-control search-input-box"
                type="text"
                placeholder="Search topics..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 32px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  fontSize: "14px",
                  marginBottom: "10px",
                }}
              />
              {searchQuery && (
                <i
                  className="bi bi-x"
                  style={{
                    position: "absolute",
                    right: "10px",
                    color: "#666",
                    cursor: "pointer",
                  }}
                  onClick={() => setSearchQuery("")}
                ></i>
              )}
            </div>
            <div className="d-flex align-items-center button-row gap-2 mb-2">
              <button className="addButton flex-grow-1 mb-0" onClick={() => handleNewSession(null)}>
                <i className="bi bi-plus"></i> New Topic
              </button>
              <button className="deleteButton mb-0" onClick={() => {setCheckedSessions([]); setActiveSessionDelete(!activeSessionDelete)}}>
                <i className="bi bi-trash"></i>
              </button>
            </div>
            {(activeSessionDelete) && (
              <div className="d-flex align-items-center button-row gap-2 mb-2">
                <button className="select-deselected flex-grow-1" onClick={() => { setCheckedSessions(filteredSessions.map(session => session.id)); }}>Select All</button>
                <button className="select-deselected flex-grow-1" onClick={() => { setCheckedSessions([]); }}>Unselect All</button>
              </div>
            )}

            {(checkedSessions.length > 0 && activeSessionDelete ) && (
              <div className="d-flex align-items-center button-row mb-2">
                <button className="deleteButton deleteAllSelected w-100 mb-0" onClick={() => { handleRemove(null);}}>Delete {checkedSessions.length} of {filteredSessions.length}</button>
              </div>
            )}
          </div>
          <ul
            className="sessionBox topic-list-minimal"
            ref={setCombinedRefs}
          >
            {filteredSessions.map((session) => {
              const childCount = allChildSessions[session.id]?.length || 0;
              const hasChildren = childCount > 0;
              const isExpanded = showSubSubMenu === session.id;
              const isActive = session.id === activeSessionId;
              const isParentOfActive = session.id === activeParentId;

              return (
                <li
                  key={session.id}
                  className={`topic-item-minimal ${isActive ? "active-topic" : ""} ${isParentOfActive ? "active-parent-topic" : ""}`}
                >
                  <div className="topic-row-minimal">
                    {activeSessionDelete && (
                      <input
                        type="checkbox"
                        className="topic-checkbox-minimal"
                        checked={checkedSessions.includes(session.id)}
                        onChange={() => handleCheckboxChange(session.id)}
                      />
                    )}

                    <Link
                      className="topic-name-minimal"
                      to="#"
                      onClick={() => handleSessionClick(session.id, null)}
                      title={session.name}
                    >
                      {session.name}
                    </Link>


                    <div className="topic-actions-minimal">
                      <button className="topic-add-btn-minimal" onClick={() => handleNewSession(session.id)} title="Add subtopic">
                        <i className="bi bi-plus"></i>
                      </button>
                      <div className="session-menu-wrapper">
                        <i
                          className="bi bi-three-dots-vertical topic-menu-btn-minimal"
                          onClick={() => handleOptionsClick(session.id)}
                        ></i>
                        {showOptions === session.id && (
                          <div
                            ref={optionsRef}
                            className="three-dot-dropdown"
                          >
                            <div
                              className="dropdown-option-hover"
                              onClick={() => handleRename(session.id)}
                            >
                              <i className="bi bi-pencil"></i>
                              Rename
                            </div>
                            <div
                              className="dropdown-option-hover dropdown-option-delete"
                              onClick={() => handleRemove(session.id)}
                            >
                              <i className="bi bi-trash"></i>
                              Remove
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <span
                      className={`topic-caret-minimal ${hasChildren ? 'has-children' : 'no-children'} ${isExpanded ? 'expanded' : ''}`}
                      onClick={() => hasChildren && handleSubSubMenuClick(session.id)}
                    >
                      {hasChildren && (
                        <i className={`bi ${isExpanded ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`}></i>
                      )}
                    </span>
                  </div>

                  {isExpanded && (
                    <div className="subtopic-list-minimal" ref={childRef}>
                      {hasChildren ? (
                        allChildSessions[session.id].map((childSession) => {
                          const isChildActive = childSession.id === activeSessionId;
                          return (
                            <div
                              className={`subtopic-item-minimal ${isChildActive ? "active-subtopic" : ""}`}
                              key={childSession.id}
                            >
                              <span className="subtopic-connector"></span>
                              <Link
                                className="subtopic-name-minimal"
                                to="#"
                                onClick={() => handleSessionClick(childSession.id, childSession.parent_session)}
                                title={childSession.name}
                              >
                                {childSession.name}
                              </Link>
                              <div className="session-menu-wrapper subtopic-menu-wrapper">
                                <i
                                  className="bi bi-three-dots-vertical subtopic-menu-btn-minimal"
                                  onClick={() => handleOptionsClick(childSession.id)}
                                ></i>
                                {showOptions === childSession.id && (
                                  <div className="three-dot-dropdown">
                                    <div
                                      className="dropdown-option-hover"
                                      onClick={() => handleRename(childSession.id)}
                                    >
                                      <i className="bi bi-pencil"></i>
                                      Rename
                                    </div>
                                    <div
                                      className="dropdown-option-hover dropdown-option-delete"
                                      onClick={() => handleRemove(childSession.id)}
                                    >
                                      <i className="bi bi-trash"></i>
                                      Remove
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="no-subtopics-minimal">No Subtopics</div>
                      )}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
          <ConfirmationPopup
            show={showRemovePopup}
            handleClose={() => setShowRemovePopup(false)}
            title="Confirm Remove"
            body="Are you sure you want to remove this session?"
            handleConfirm={() =>
              confirmRemove(sessionToRemove == null ? true : false)
            }
            isLoading={Loader}
          />
          <SessionPopup
            show={showFormPopup}
            handleClose={handleClosePopup}
            title={isNewSession ? (sessionToRename ? "New Subtopic" : "New Topic") : "Rename"}
            button={isNewSession ? "Create" : "Save"}
            handleConfirm={(newName, setError) =>
              confirmRename(newName, setError)
            }
            initialValue={
              isNewSession
                ? ""
                : sessions.find((session) => session.id === sessionToRename)
                    ?.name ||
                  Object.values(childSessions)
                    .flat()
                    .find((session) => session.id === sessionToRename)?.name ||
                  ""
            }
          />
        </div>
      )}
    </>
  );
}

export default MainSession;
